import { ReactiveValue } from '@app/packages/reactives/ReactiveValue'

export class WindowFocusTracker {
  readonly isFocused = new ReactiveValue<boolean>(false)
  private stack = new DisposableStack()

  constructor() {
    const updateFocus = () => {
      this.isFocused.update(() => document.hasFocus())
    }

    updateFocus()

    window.addEventListener('focus', updateFocus)
    this.stack.defer(() => window.removeEventListener('focus', updateFocus))
    window.addEventListener('blur', updateFocus)
    this.stack.defer(() => window.removeEventListener('blur', updateFocus))
  }

  [Symbol.dispose]() {
    this.stack.dispose()
  }
}
